import { Image } from "react-bootstrap";
import PropTypes from "prop-types";

import { relationshipStrategyToField } from "../helpers/reportHelpers";
import { useUser } from "../../UserContext";

import DependantImage from "../../../assets/icons/dependent.png";
import DisconnectedImage from "../../../assets/icons/disconnected.png";
import IndependentImage from "../../../assets/icons/independent.png";
import InterdependentImage from "../../../assets/icons/interdependent.png";

const imageMap = {
	dependent: DependantImage,
	disconnected: DisconnectedImage,
	independent: IndependentImage,
	interdependent: InterdependentImage
}

const RSBadge = ({ strategy }) => {
	const { respondent } = useUser();
	const stats = respondent?.weqProfile?.stats || {};
	const strategyField = relationshipStrategyToField[strategy.toLowerCase()];
	if (typeof stats[strategyField] === "undefined") {
		return null;
	}
	return (
		<div className={`emotion-badge align-items-center fs-18 gap-1 d-flex strategy-badge--${strategy.toLowerCase()}`}>
			<Image alt={strategy} className="me-2" src={imageMap[strategy.toLowerCase()]} style={{ minWidth: '48px', width: '20%' }} />
			<div className="d-flex flex-column">
				<div className="fw-bold d-flex align-items-center">
					<span className={`rounded-circle d-inline-block bg-eqqo-${strategy.toLowerCase()} me-1`} height="10" style={{ height: "10px", width: "10px" }} width="10" />
					{strategy}
				</div>
				<div className="emotion-badge__score text-secondary">
					{stats[`${strategyField}_dist`]?.toFixed(2)}%
				</div>
			</div>
		</div>
	);
};

RSBadge.propTypes = {
	strategy: PropTypes.string.isRequired
};

export default RSBadge;